import CloseRounded from "@mui/icons-material/CloseRounded";
import IosShareRoundedIcon from "@mui/icons-material/IosShareRounded";
import { detect } from "detect-browser";
import React, { useEffect, useState } from "react";
import createPersistedState from "use-persisted-state";
import appIconImage from "../../../../images/icons/icon-144x144.png";
import { siteId } from "../../../constants";
import { Outer, Inner, Icon, Title, Subtitle, Copy, CloseButton } from "./styled";

const usePwaInstallPromptSeeenCount = createPersistedState(
    `headstart.${siteId}.pwa-install-prompt-renders`,
);
const usePwaInstallPromptClosed = createPersistedState(`headstart.${siteId}.pwa-install-closed`);

const isInstalled = () => {
    if (matchMedia("(display-mode: standalone)").matches) {
        return true;
    }
    if (window.navigator.standalone === true) {
        return true;
    }
    return false;
};

export const PWAInstallPrompt = () => {
    const [timesSeen, setTimesSeen] = usePwaInstallPromptSeeenCount<number>(0);
    const [hasBeenClosed, setHasbeenClosed] = usePwaInstallPromptClosed<boolean>(false);
    const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        const browser = detect();
        if (browser?.type === "browser") {
            if (browser.os === "iOS" && ["ios", "safari"].includes(browser.name)) {
                if (timesSeen > 0) {
                    setIsShowing(true);
                }
            }
        }
        setTimesSeen(timesSeen + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isShowing || hasBeenClosed || isInstalled()) {
        return null;
    }

    return (
        <Outer>
            <Inner>
                <Icon src={appIconImage} alt="" />
                <Copy>
                    <Title>Install Headstart to your home screen</Title>
                    <Subtitle>
                        Tap <IosShareRoundedIcon /> and then &lsquo;Add to Home Screen&rsquo;
                    </Subtitle>
                </Copy>
                <CloseButton onClick={() => setHasbeenClosed(true)}>
                    <CloseRounded />
                </CloseButton>
            </Inner>
        </Outer>
    );
};
